<ng-content></ng-content> <!-- This is optional, for projecting description content. --> 
<wfdss-configurable-mat-table
[dataSource] = "tableDs"
[columnMetaInformationIn] = "columnMetaInformation"
[showFilter]="true"
[showExport]="true"
[fixedLayout] = "false"
[filterLabel]="'Filter by Title, Type, or Created by'"
[sortActive]="sortActive"
[sortDirection]="sortDirection"
[sortingDataAccessor]="sortingDataAccessor"
[exportPrefix]="'incName'"
[exportSuffix]="'IncidentAnalyses'"
(rowClick)="onRowClick($event)"
></wfdss-configurable-mat-table>

<!-- <wfdss-configurable-mat-table
[dataSource] = "existingAnalyses.dataSource"
[columnMetaInformationIn] = "existingAnalyses.columnMeta"
[csvDataColumns]="displayCsvDataColumns"
[showFilter]="true"
[showExport]="true"
[fixedLayout] = "false"
[filterPredicate]="filterPredicate()"
[filterLabel]="'Filter by Analysis Name, Analyst Name, or Analysis Type'"
[sortActive]="sortActive"
[sortDirection]="sortDirection"
[sortingDataAccessor]="sortingDataAccessor"
[exportPrefix]="incName"
[exportSuffix]="'IncidentAnalyses'"
(rowClick)="existingAnalysisRowClicked($event)"
(tableEvent)="handTableEvent($event)"
></wfdss-configurable-mat-table> -->